import React, {Component} from 'react';
import {getSubFormFieldByType, sanitizeFieldName} from "../../util/methods";
import {AutoComplete, Button, Checkbox, Form, Icon, message, Popover, Select, Typography, Upload} from 'antd';
import SubList from "../../components/SubList";
import moment from 'moment';

const {Text} = Typography;

class Assets extends Component {
  id = 0;
  state = {
    keys: [],
    willUpload: false,
    fileList: [],
    uploading: false,
    docs: [],
  };

  componentDidMount() {
    const {data = [{}]} = this.props;
    this.setState({
      keys: [{}],
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      this.setState({
        keys: nextProps.data,
      });
    }
    //console.log(nextProps.contractUploading, this.props.contractUploading);
    if (nextProps.contractUploading !== this.props.contractUploading) {
      this.setState({
        uploading: nextProps.contractUploading,
      })
    }
    // console.log(nextProps.docData, this.props.docData);
    if (nextProps.docData !== this.props.docData) {
      this.setState({
        docs: nextProps.docData,
      })
    }
  }

  remove = index => {
    const {keys} = this.state;
    const {form, item} = this.props;
    const {field} = item;
    if (keys.length === 0) {
      return;
    }
    const val = form.getFieldValue(field);
    val.splice(index, 1);

    keys.splice(index, 1);
    for (let i = 0; i < val.length; i++) {
      Object.keys(item.schema).map((item, index) => {
        form.setFieldsValue({
          [`${field}[${i}][${item}]`]: val[i][item],
        });
      });
    }
    this.setState({
      keys: keys,
    });
  };

  add = () => {
    const {item: {field}} = this.props;
    const {keys} = this.state;
    keys.push(`${field}${this.id++}`);
    this.setState({
      keys: keys,
    });
  };

  handleUpload = () => {
    const {fileList} = this.state;
    const formData = new FormData();
    fileList.forEach(file => {
      formData.append('files[]', file);
    });
    // formData.append(key, payload[key]);

    const vendor = this.props.form.getFieldValue('vendor');
    const agreementDate = this.props.form.getFieldValue('agreementDate');
    const agreementPeriodFrom = this.props.form.getFieldValue('agreementPeriodFrom');
    const agreementPeriodTo = this.props.form.getFieldValue('agreementPeriodTo');
    const prevContract = this.props.form.getFieldValue('prevContract');
    const nextContract = this.props.form.getFieldValue('nextContract');

    if (!vendor || !moment(agreementDate).isValid() || !moment(agreementPeriodFrom).isValid() || !moment(agreementPeriodTo).isValid())
      message.error("Please add contract details first");
    else {
      this.setState({
        uploading: true,
      });


      // data.documents = this.props && this.props.data && this.props.data.documents;


      this.props.createResourceWithExcel(fileList, {
        documents: this.props && this.props.docData,
        assetUpload: true,
        vendor,
        agreementDate,
        agreementPeriodFrom,
        agreementPeriodTo,
        prevContract,
        nextContract
      });
    }

    // axios.post(`/contract`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}})
    //   .then((response) => {
    //     console.log(response);
    //     this.setState({
    //       fileList: [],
    //       uploading: false,
    //     });
    //     message.success('upload successfully.');
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //     this.setState({
    //       uploading: false,
    //     });
    //     message.error('upload failed.');
    //   });
  };

  onChangeUploadBtn = (e) => {
    this.props.disableCreateBtn(e.target.checked);
    this.setState({
      willUpload: e.target.checked
    })
  }

  templateContent = (
    <div>
      <p>CSV file template</p>
      <Button size={'small'} onClick={() => {
        window.open('../csv_template/ContractAssetsTemplate.csv', '_blank');
      }}>Download</Button>
    </div>
  );

  render() {
    const {getFieldDecorator, getFieldValue, getFieldsValue, setFieldsValue} = this.props.form;
    const {form, item, data = [], hideAddButton = false, resource, superMaster, subMaster} = this.props;
    const {field} = item;
    const {keys} = this.state;
    const style = {
      marginTop: '10px',
      // border: '5px solid #000',
      padding: '20px',
      // borderRadius: '9px',
      borderStyle: 'none none none solid',
      borderColor: '#038fde',
      borderWidth: '10px'
    };

    const formItems = keys.map((k, index) => (

      <div key={index} style={style}>
        {
          Object.keys(this.props.item.schema).map((fieldName, innerIndex) => {

            if (fieldName === 'leasingAsset' || fieldName === 'suspendedAsset') {
              return <Form.Item key={`${index}${innerIndex}`} label={'Enter Asset'} style={{width: '100%'}}>
                {getFieldDecorator(`${field}[${index}][${item.schema[fieldName].field}]`,
                  {
                    rules: [{
                      required: true,
                      message: `${sanitizeFieldName(fieldName)} is required!`
                    }],
                    initialValue: data[index] && data[index][fieldName] && data[index][fieldName].assetCode,
                  })
                (<AutoComplete onSearch={this.props.assetSearch}
                               placeholder={'Asset Code'}
                               disabled={(this.props.title === 'EDIT' && data[index] && data[index][fieldName]) ? true : false}>
                  {
                    (this.props.assetData || []).map(item => (
                      <Select.Option key={item._id} value={item._id}>{item.assetCode}</Select.Option>))
                  }
                </AutoComplete>)}
              </Form.Item>
            } else if (fieldName === 'suspensionDocuments') {

              return null;
              /*<DocumentList match={this.props.match} history={this.props.history}
                                                key={item.schema.suspensionDocuments} item={item.schema.suspensionDocuments}
                                                form={form} data={data[item.schema.suspensionDocuments]}
                                                subDocumentFilters={this.props.subDocumentFilters}
                                                getDocumentData={this.props.getDocumentData}/>*/

            } else {
              if (item.schema[fieldName].type === 'Array' && item.schema[fieldName].schema && fieldName !== 'suspensionInfo') {
                // console.log(this.props);

                return <SubList key={item.schema[fieldName] + '-' + innerIndex} item={item.schema[fieldName]}
                                form={form} parent={`assets[${index}]`} pindex={index}
                                data={data && data[item]} title={this.props.title}
                                resource={resource} assetSearch={this.props.assetSearch}
                                assetData={this.props.assetData}/>

                //   <Assets key={item} item={filters[item]} form={form} data={data && data[item]} title={title}
                // resource={resource} assetSearch={this.props.assetSearch}
                // assetData={this.props.assetData}/>
              } else {
                return getSubFormFieldByType(item.schema[fieldName], getFieldDecorator, data[index], `${index}${innerIndex}`, field, index, {
                  title: 'CREATE',
                  resource,
                  superMaster: (superMaster || false),
                  subMaster: (subMaster || false),
                  setFieldsValue,
                });
              }
            }
          })
        }

        {index >= 0 && !hideAddButton ? (
          <Icon
            className="dynamic-delete-button"
            type="minus-circle-o"
            onClick={() => this.remove(index)}
          />
        ) : null}
      </div>
    ));

    const {uploading, fileList} = this.state;
    const uploadProps = {
      accept: '.csv',
      onRemove: file => {
        this.setState(state => {
          const index = state.fileList.indexOf(file);
          const newFileList = state.fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList,
          };
        });
      },
      beforeUpload: file => {
        this.setState(state => ({
          fileList: [/*...state.fileList,*/ file],
        }));
        return false;
      },
      fileList,
    };


    return (
      <div>
        <div><Checkbox onChange={this.onChangeUploadBtn}>
          <Text>Upload Assets</Text>
        </Checkbox><Popover content={this.templateContent} title="" trigger="click">
          <Button type="default" shape="circle" icon="download" size={'small'}/>
        </Popover></div>
        {
          this.state.willUpload ?
            <div>
              <Upload {...uploadProps}><Button><Icon type="upload"/>Upload Excel</Button></Upload><Button
              type="primary"
              onClick={this.handleUpload}
              disabled={fileList.length === 0}
              loading={uploading || this.props.loading}
              style={{marginTop: 16}}
            >
              {uploading ? 'Uploading' : 'Start Upload'}
            </Button></div> :
            <div>{formItems}
              {
                this.props && this.props.hideAddButton ? <br/> : <Form.Item>
                  <Button type="ghost" onClick={this.add} style={{width: '60%', marginTop: '15px'}}>
                    <Icon type="plus"/> Add More {sanitizeFieldName(item.field)}
                  </Button>
                </Form.Item>
              }</div>
        }

      </div>

    );
  }
}

Assets.propTypes = {};

export default Assets;
